<template>
    <div class="wf-product-category-refinements sticky-top filterPadding">
        <div class="wf-product-refinement-list wf-product-refinement-list-expanded" v-for="filter in availableFilters"
            :key="filter.name">
            <div class="wf-product-refinement-list-header">
                <button type="button" class="btn wf-product-refinement-list-header-toggle collapsed" data-toggle="collapse"
                    :data-target="`.wf-product-refinement-collapse-${filter.azureFilterName.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-')}`">
                    {{ filter.name }}
                    <span
                        class="png-icon png-icon-icons-glyph--k-btn-minus-active wf-product-refinement-list-header-toggle-inactive" />
                    <span
                        class="png-icon png-icon-icons-glyph--k-btn-expand-ol wf-product-refinement-list-header-toggle-active" />
                </button>
            </div>
            <div class="wf-product-refinement-list-items collapse"
                :class="`wf-product-refinement-collapse-${filter.azureFilterName.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-')}`">
                <div>
                    <div class="wf-product-refinement-list-item custom-control custom-checkbox">
                        <div v-for="item in filter.options" :key="filter.name + '-' + item">
                            <input class="custom-control-input" type="checkbox" :id="filter.name + '-' + item" :value="item"
                                :checked="selectedFilters[filter.azureFilterName] &&
                                    selectedFilters[filter.azureFilterName].some(i => i.toLowerCase() === item.toLowerCase())"
                                @click="onFilterClick({ filterName: filter.azureFilterName, option: item })">
                            <label :data-data="filter.azureFilterName" class="custom-control-label"
                                :for="filter.name + '-' + item">
                                {{ item }}
                            </label>
                        </div>
                    </div>
                    <div slot="showMoreLabel" slot-scope="{ isShowingMore }">
                        <div class="btn view-more-button" v-if="isShowingMore">
                            <span class="mr-1">{{ $resourceString["product.search.side.filters.view.less"] }}</span>
                            <span class="png-icon png-icon-icons-glyph--red-btn-minus-active" />
                        </div>
                        <div class="btn view-more-button" v-else>
                            <span class="mr-1">{{ $resourceString["product.search.side.filters.view.more"] }}</span>
                            <span class="png-icon png-icon-icons-glyph--red-btn-expand-active" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
import "vue-slider-component/theme/default.css";

export default {
    components: {},
    computed: {
        ...mapGetters({
            filters: "filters/filters",
            selectedFilters: "filters/selectedFilters",
        }),
        availableFilters() {
            return this.filters.filter(f => f.options.length);
        }
    },
    data() {
        return {
            refinements: this.defaultRefinements,
            isMobileView: false,
        };
    },
    methods: {
        ...mapActions({
            onFilterClick: "filters/onFilterClick",
        }),
    },
}; 
</script>
<style>
.filterPadding {
    padding-top: 3rem;
}
</style>